import { z } from "zod";
import stringSchema from "@/lib/utils/stringSchema";

const TicketsInternalTicketTypeSchema = z.object({
  id: z.union([z.number(), z.string()]).optional(), // Optional for updates
  internal_ticket_type_id: z.union([z.number(), z.string().min(1, "Internal Ticket Type ID is required")]),
  internal_sub_ticket_type_id: z.union([z.number(), z.string().min(1, "Internal Sub Ticket Type ID is required")]),
  internal_sub_ticket_type_count: z.number(),
  _destroy: z.boolean().optional(), // Optional for updates
});

const formSchema = z.object({
  account_id: stringSchema({ key: "Account", required: true }),
  internal_owner_id: stringSchema({ key: "Internal Owner", required: true }),
  sow_id: stringSchema({ key: "Sow", required: true }),
  subject: stringSchema({ key: "Subject", required: true }),
  description: stringSchema({ key: "Description", required: true }),
  due_date: z.date().optional().nullable(),
  priority_id: stringSchema({ key: "Priority", required: true }),
  owner_id: stringSchema({ key: "Owner", required: true }),
  ticket_type_id: stringSchema({ key: "Ticket Type", required: true }),
  sub_ticket_type_id: z.string().optional().nullable(),
  tickets_internal_ticket_types_attributes: z.array(TicketsInternalTicketTypeSchema),
  region_id: z.string().optional().nullable(),
  country_ids: z.array(z.string()).min(1, "Country is required"),
  function_id: stringSchema({ key: "Function", required: true }),
  sub_function_id: z.string().optional().nullable(),
  department_id: z.string().optional().nullable(),
  sub_department_id: z.string().optional().nullable(),
});

export default formSchema;